import Proxy from './Proxy';

class AmmProxy extends Proxy {
    constructor(parameters = {}) {
        super('/amm', parameters);
    }
}

export default AmmProxy;
